"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSnapPlot = void 0;
const ml_spectra_processing_1 = require("ml-spectra-processing");
const calculateSanPlot_1 = require("../../../../../data/utilities/calculateSanPlot");
function processSnapPlot(dimension, data, yLogBase) {
    const sanResult = (0, calculateSanPlot_1.calculateSanPlot)(dimension, data);
    const sanPlot = {};
    const lines = {};
    for (const plotKey in sanResult.sanplot) {
        const { x, y } = (0, ml_spectra_processing_1.xyReduce)(sanResult.sanplot[plotKey]);
        const result = new Array(x.length);
        for (let i = 0; i < x.length; i++) {
            result[i] = { x: x[i], y: y[i] };
        }
        sanPlot[plotKey] = result;
        lines[plotKey] = getLine(sanResult[plotKey], result, { yLogBase });
    }
    return { sanPlot, lines };
}
exports.processSnapPlot = processSnapPlot;
function getLine(value, data, options) {
    const { log10, abs } = Math;
    const { yLogBase } = options;
    const first = data.at(0)?.x ?? 0;
    const last = data.at(-1)?.x ?? 0;
    const inLogScale = log10(abs(value)) / log10(yLogBase);
    return [
        { x: first, y: inLogScale },
        { x: last, y: inLogScale },
    ];
}
